import { c as _c } from "react/compiler-runtime";
import { usePageView } from '@/analytics/pageTypes';
import { SeoHeader } from '@/components/SeoHeader';
import { Layout } from '@/components/layout';
import Hero from '@/sections/Hero';
import { getIntlProps, type IntlProps } from '@/utils/intl';
import type { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { SectionDelimiter } from '@/components/SectionDelimiter';
import React from 'react';
import { MoreInfo } from '@/sections/mallpay/MoreInfo';
import { Faqs } from '@/sections/mallpay/Faqs';
import { LINKS } from '@/constants/links';
import { FaqIntro } from '@/sections/FaqIntro';
import { WhatItMeans } from '@/sections/mallpay/WhatItMeans';
import { Shopping } from '@/sections/mallpay/Shopping';
import { News } from '@/sections/mallpay/News';
import { Ceo } from '@/sections/mallpay/Ceo';
import { AboutSkipPAy } from '@/sections/mallpay/AboutSkipPay';
import { getPageBannerBySlug, PageBanner } from '@/api/sanity/pageBanners';
import { isAllowedRoute } from '@/lang/pagesConfig';
import { getAllPageMenuPromoBanners, PageMenuPromoBanner } from '@/api/sanity/pageMenuPromoBanner';
interface Props extends IntlProps {
  pageBanner: PageBanner | null;
  menuPromoBanners?: PageMenuPromoBanner[];
}
export default function Page(t0) {
  const $ = _c(63);
  const {
    pageBanner,
    menuPromoBanners
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["mallpay", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  usePageView("mallpay");
  let t2;
  if ($[1] !== t) {
    t2 = t("seo.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("seo.description");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <SeoHeader title={t2} description={t3} />;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="hidden">mallpay neznal jsem, ale RIP</div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SeoHeader title="" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = pageBanner?.videoId;
  let t8;
  if ($[10] !== pageBanner?.title || $[11] !== t) {
    t8 = pageBanner?.title ?? t("banner.title");
    $[10] = pageBanner?.title;
    $[11] = t;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== pageBanner?.text || $[14] !== t) {
    t9 = pageBanner?.text ?? t("banner.text");
    $[13] = pageBanner?.text;
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== pageBanner || $[17] !== t) {
    t10 = pageBanner ? pageBanner.buttons : [{
      ariaLabel: t("banner.cta"),
      label: t("banner.cta"),
      to: LINKS().registration,
      testId: "mallpayHeroPrimaryCTA",
      analyticsParam: "mallpayHeroPrimaryCTA",
      variant: "primary"
    }];
    $[16] = pageBanner;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = pageBanner?.image?.url ?? "/images/sections/mallpay/hero/hero.png";
  let t12;
  if ($[19] !== pageBanner?.image?.alt || $[20] !== t) {
    t12 = pageBanner?.image?.alt ?? t("banner.title");
    $[19] = pageBanner?.image?.alt;
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = {
      url: t11,
      alt: t12
    };
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = pageBanner?.variant || "mascots";
  let t15;
  if ($[25] !== t10 || $[26] !== t13 || $[27] !== t14 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t15 = <Hero videoId={t7} title={t8} text={t9} buttons={t10} image={t13} variant={t14} />;
    $[25] = t10;
    $[26] = t13;
    $[27] = t14;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="bg-blue-50"><SectionDelimiter color="bg-blue-100" background="bg-transparent" /></div>;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="bgCircle absolute top-0 left-0 hidden -translate-x-1/4 translate-y-2/3 rotate-90 lg:block lg:h-96 lg:w-96" />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="relative z-30 scroll-mt-20 bg-blue-100 pt-10 pb-20 lg:pt-20 lg:pb-40">{t17}<div className="relative z-10 flex flex-col gap-20 lg:gap-40"><WhatItMeans /><AboutSkipPAy /></div></div>;
    t19 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[34] = t18;
    $[35] = t19;
  } else {
    t18 = $[34];
    t19 = $[35];
  }
  let t20;
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="bgCircle lg:top:0 absolute top-20 right-0 translate-x-3/4 lg:translate-x-2/3" />;
    t21 = <div className="bgCircle absolute right-2/3 bottom-20 rotate-90 lg:h-96 lg:w-96 lg:-translate-x-1/4" />;
    $[36] = t20;
    $[37] = t21;
  } else {
    t20 = $[36];
    t21 = $[37];
  }
  let t22;
  let t23;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="relative bg-blue-50 pt-10 pb-20 lg:pt-20 lg:pb-40">{t20}{t21}<div className="relative z-10 flex flex-col gap-20 lg:gap-40"><News /><Ceo /></div></div>;
    t23 = <SectionDelimiter color="bg-blue-100" background="bg-blue-50" />;
    $[38] = t22;
    $[39] = t23;
  } else {
    t22 = $[38];
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="bgCircle absolute bottom-1/3 left-1/2 translate-x-1/2 -translate-y-10 rotate-90 lg:bottom-0 lg:translate-x-2/3 lg:-translate-y-20" />;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  let t26;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="relative bg-blue-100 pt-10 pb-20 lg:pt-20 lg:pb-40">{t24}<div className="relative z-10 flex flex-col gap-20 lg:gap-40"><Shopping /></div></div>;
    t26 = <SectionDelimiter color="bg-blue-50" background="bg-blue-100" />;
    $[41] = t25;
    $[42] = t26;
  } else {
    t25 = $[41];
    t26 = $[42];
  }
  let t27;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Faqs />;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = LINKS();
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  const t29 = t28.faq;
  let t30;
  if ($[45] !== t) {
    t30 = t("faq.text");
    $[45] = t;
    $[46] = t30;
  } else {
    t30 = $[46];
  }
  let t31;
  if ($[47] !== t30) {
    t31 = <FaqIntro link={t29} text={t30} />;
    $[47] = t30;
    $[48] = t31;
  } else {
    t31 = $[48];
  }
  let t32;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <MoreInfo />;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== t31) {
    t33 = <div className="relative z-10 flex flex-col gap-20 lg:gap-40">{t27}{t31}{t32}</div>;
    $[50] = t31;
    $[51] = t33;
  } else {
    t33 = $[51];
  }
  let t34;
  let t35;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <div className="bgCircle absolute top-1/4 left-0 -translate-x-1/3 rotate-90" />;
    t35 = <div className="bgCircle absolute right-0 bottom-0 translate-x-1/4 translate-y-1/4 rotate-180" />;
    $[52] = t34;
    $[53] = t35;
  } else {
    t34 = $[52];
    t35 = $[53];
  }
  let t36;
  if ($[54] !== t33) {
    t36 = <div className="relative overflow-hidden bg-blue-50 py-10 lg:py-20">{t33}{t34}{t35}</div>;
    $[54] = t33;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  let t37;
  if ($[56] !== t15 || $[57] !== t36) {
    t37 = <div className="relative overflow-x-hidden">{t6}{t15}{t16}{t18}{t19}{t22}{t23}{t25}{t26}{t36}</div>;
    $[56] = t15;
    $[57] = t36;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  let t38;
  if ($[59] !== menuPromoBanners || $[60] !== t37 || $[61] !== t4) {
    t38 = <Layout menuPromoBanners={menuPromoBanners}>{t4}{t5}{t37}</Layout>;
    $[59] = menuPromoBanners;
    $[60] = t37;
    $[61] = t4;
    $[62] = t38;
  } else {
    t38 = $[62];
  }
  return t38;
}
export const getStaticProps = (async ctx => {
  const isAllowed = isAllowedRoute('mallpay');
  if (!isAllowed) {
    return {
      notFound: true
    };
  }
  return {
    props: {
      pageBanner: await getPageBannerBySlug('mallpay'),
      menuPromoBanners: await getAllPageMenuPromoBanners(),
      ...(await getIntlProps(ctx, ['core', 'mallpay', 'testimonials']))
    }
  };
}) satisfies GetStaticProps<Props>;